import { StackedBarFormat, SingleValueBarFormat } from '../BarChart.types';

const changeMultipleColumnToSingleColumn = (data: StackedBarFormat): SingleValueBarFormat => {
  const newData: number[] = [];
  Object.keys(data.data).forEach((key) => {
    newData.push(data.data[key]);
  });
  const finalValue = newData.reduce((acc, curr) => acc + curr, 0);
  return {
    value: finalValue,
    groupValue: data.name,
  };
};

export const changeMultipleColumnToSingleColumnArray = (data: StackedBarFormat[]): SingleValueBarFormat[] => {
  return data.map(changeMultipleColumnToSingleColumn);
};

export const changeMultipleColumnToReChartStackedFormat = (
  data: StackedBarFormat[],
): Array<{ [key: string]: number | string }> => {
  return data.map((d) => {
    return {
      groupValue: d.name,
      ...d.data,
    };
  });
};
